import type * as React from 'react';

import type { TestimonialItem } from '@coursera-web/cds-labs';

import imageAbdullahiM from 'images/front-page/Testimonial-AbdullahiM.jpg';
import imageAnasA from 'images/front-page/Testimonial-AnasA.jpg';
import imageNoerisB from 'images/front-page/Testimonial-NoerisB.jpg';
import imageSarahW from 'images/front-page/Testimonial-SarahW.jpg';

import _t from 'i18n!nls/front-page';

const getDefaultTestimonials = (): Array<React.ComponentProps<typeof TestimonialItem>> => {
  return [
    {
      name: 'Sarah W.',
      imageSrc: imageSarahW,
      quote: _t(
        `Coursera's reputation for high-quality content, paired with its flexible structure, made it possible for me to dive into data analytics while managing family, health, and everyday life.`
      ),
    },
    {
      name: 'Noeris B.',
      imageSrc: imageNoerisB,
      quote: _t(
        `Coursera rebuilt my confidence and showed me I could dream bigger. It wasn't just about gaining knowledge—it was about believing in my potential again.`
      ),
    },
    {
      name: 'Abdullahi M.',
      imageSrc: imageAbdullahiM,
      quote: _t(
        'I now feel more prepared to take on leadership roles and have already started mentoring some of my colleagues.'
      ),
    },
    {
      name: 'Anas A.',
      imageSrc: imageAnasA,
      quote: _t(
        'Learning with Coursera has expanded my professional expertise by giving me access to cutting-edge research, practical tools, and global perspectives.'
      ),
    },
  ];
};

export default getDefaultTestimonials;
